import React from "react"
import TextField from "@mui/material/TextField"

const LongText = ({value, label, rows}) => {
    return (
        <TextField
            label={label}
            value={value}
            multiline
            rows={rows}
        />
    )
}

export default LongText
